import { loader } from 'graphql.macro'

export default async function updateTicketById ({ dataLoaders, variables }) {
  const schema = loader('./updateTicketById.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, { input: variables })
  return response.updateTicketById
}
